import EditEventController from './edit';
import EventDetailController from './detail';
import HighlightsController from './highlights';
import TrimRecordingsController from './trim-recordings';
import scoreboardControls from './scoreboard-controls';
import playerWithHighlightCapture from './player-with-highlight-capture';

// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.
let module = angular.module('events', []);

module.controller('EditEventController', EditEventController);
module.controller('EventDetailController', EventDetailController);
module.controller('HighlightsController', HighlightsController);
module.controller('TrimRecordingsController', TrimRecordingsController);
module.directive('scoreboardControls', scoreboardControls);
module.component('playerWithHighlightCapture', playerWithHighlightCapture);

module.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state('events', {
      url: '/events',
      template: `<div ui-view></div>`,
      abstract: true,
    })
    .state('events.detail', {
      url: '/:id?tab&action&from_producer',
      template: require('./detail.html'),
      controller: EventDetailController,
      controllerAs: 'vm',
      reloadOnSearch: false,
    })
    .state('events.trim', {
      url: '/:id/trim/:recording',
      template: require('./trim-recordings.html'),
      controller: TrimRecordingsController,
      controllerAs: 'vm',
    })
    .state('events.highlights', {
      url: '/:id/highlights/:recording',
      template: require('./highlights.html'),
      controller: HighlightsController,
      controllerAs: 'vm',
    });
  //.state('events.edit', {
  //  url: '/:id/edit',
  //  template: require('./edit.html'),
  //  controller: EditEventController,
  //  controllerAs: 'vm',
  //})
});

export default module;



// WEBPACK FOOTER //
// ./app/pages/events/_index.js